module.exports = "/_next/static/images/ed374078465ac78b489b7798d4aa74fb-product-information-lg-1x.jpg";